package app.footyguide.web.theme

import kotlinx.browser.document
import org.w3c.dom.HTMLElement

private val THEME_KEYS = listOf(
    "--bg",
    "--surface",
    "--accent",
    "--accent-secondary",
    "--accent-tertiary",
    "--fg",
    "--muted",
    "--border",
    "--banner-bg",
)

data class ThemeSnapshot(
    val cssVars: Map<String, String>,
    val dataTheme: String?,
    val themeColor: String?,
)

fun captureThemeSnapshot(): ThemeSnapshot {
    val root = document.documentElement as? HTMLElement
    val cssVars = THEME_KEYS.associateWith { key ->
        root?.style?.getPropertyValue(key).orEmpty()
    }
    val themeColor = document.querySelector("meta[name=\"theme-color\"]")
        ?.getAttribute("content")

    return ThemeSnapshot(
        cssVars = cssVars,
        dataTheme = root?.getAttribute("data-theme"),
        themeColor = themeColor,
    )
}

fun ThemeSnapshot.restore() {
    val root = document.documentElement as? HTMLElement ?: return
    cssVars.forEach { (key, value) ->
        if (value.isBlank()) {
            root.style.removeProperty(key)
        } else {
            root.style.setProperty(key, value)
        }
    }

    if (dataTheme.isNullOrBlank()) {
        root.removeAttribute("data-theme")
    } else {
        root.setAttribute("data-theme", dataTheme)
    }

    val meta = document.querySelector("meta[name=\"theme-color\"]")
    if (themeColor.isNullOrBlank()) {
        meta?.removeAttribute("content")
    } else {
        meta?.setAttribute("content", themeColor)
    }
}
